export const {
  ENV_KEY,
  API_ROOT,
} = window.__ENV__;
